import { getNewRelicAgent } from 'newRelicAgent';

import { enableScriptForServiceWithConsent } from 'utils/enable-script-for-service-with-consent';
import { loadScript } from 'utils/loadScript';
import { usercentricsEnabled } from 'utils/usercentrics';
import { usercentricsServiceNames } from 'utils/usercentrics-content-change-event-listener';
import { usercentricsServiceStatus } from 'utils/usercentrics-service-status';

export const loadMicrosoftTeamsSDK = () => {
  const teamsConfig = {
    id: 'ms-teams-share-launcher-js',
    src: 'https://teams.microsoft.com/share/launcher.js',
    defer: true,
  };

  if (usercentricsEnabled()) {
    teamsConfig.type = 'text/plain';
    teamsConfig.dataset = {
      usercentrics: usercentricsServiceNames.microsoftTeams,
    };

    loadScript(teamsConfig);

    enableScriptForServiceWithConsent();

    return usercentricsServiceStatus(usercentricsServiceNames.microsoftTeams) ? Promise.resolve() : Promise.reject();
  } else {
    return loadScript(teamsConfig).catch(() => {
      getNewRelicAgent().noticeError(new Error('Share to MS-Teams: SDK cannot be loaded.'));
    });
  }
};
